module.exports = __webpack_public_path__ + "img/jctrans.49bd5bfa.png";